import { loadReCaptchaScript } from '../../utils/reCaptcha';
import { PropsWithChildren, useEffect } from 'react';

function ReCaptchaProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    loadReCaptchaScript();
  }, []);

  return <>{children}</>;
}

export default ReCaptchaProvider;
